import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Package, ArrowSquareOut, MapPin, UploadSimple, LockSimple } from "@phosphor-icons/react";
import client from "../lib/api";
import { STATUS, money, coverImage, onPropImgError } from "../lib/helpers";
import { Badge } from "../components/ui/badge";

export default function DeliverablesPanel({ role, onOpenProperty }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => client.get("/deliverables").then((r) => { setItems(r.data.items); setLoading(false); }).catch(() => setLoading(false));
  useEffect(() => { load(); const iv = setInterval(load, 5000); return () => clearInterval(iv); }, []);

  if (loading) return <p className="text-[#5C5A58]">Loading…</p>;
  if (items.length === 0) return (
    <div className="text-center py-24 text-[#5C5A58]" data-testid="deliverables-empty">
      <Package size={48} weight="duotone" className="mx-auto mb-4 text-[#4A0000]" />
      <p>{role === "agent" ? "No deliverables ready yet. You'll be notified when a shoot is complete." : role === "photographer" ? "No shoots assigned yet. Delivery links will appear here." : "No deliverables links yet."}</p>
    </div>
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-testid="deliverables-panel">
      {items.map((p, i) => {
        const st = STATUS[p.status] || STATUS.scheduled;
        return (
          <motion.div key={p.property_id} data-testid={`deliverable-${p.property_id}`}
            initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.04 }}
            className="card-shoot">
            <div className="h-32 bg-[#FAF9F6] overflow-hidden relative">
              <img src={coverImage(p)} alt={p.title} onError={onPropImgError} className="block w-full h-full object-cover object-top" />
              <Badge className={`absolute top-3 left-3 border shadow-sm font-medium backdrop-blur-sm !bg-white/90 ${st.cls}`}>{st.label}</Badge>
              {p.locked
                ? <span className="pill pill--gold absolute top-3 right-3"><LockSimple size={11} weight="fill" />Locked</span>
                : p.ready && <span className="pill pill--paid absolute top-3 right-3">Ready</span>}
            </div>
            <div className="p-4 flex-1 flex flex-col">
              <button onClick={() => onOpenProperty(p.property_id)} className="text-left">
                <h3 className="font-display text-xl leading-tight hover:text-[#4A0000] transition-colors">{p.title}</h3>
                <p className="text-xs text-[#5C5A58] flex items-center gap-1 mt-1"><MapPin size={12} weight="duotone" />{p.address}{p.zip ? ` · ${p.zip}` : ""}</p>
              </button>
              <div className="mt-4 pt-3 border-t border-[#FAF9F6] mt-auto">
                {p.locked
                  ? <button onClick={() => onOpenProperty(p.property_id)} data-testid={`locked-deliverable-${p.property_id}`}
                      className="flex items-center justify-center gap-2 w-full bg-[#FAF9F6] text-[#8A6D1B] border border-[#E4D08A] rounded-md py-2 text-sm font-medium hover:bg-[#F0E9D6] transition-colors">
                      <LockSimple size={16} weight="fill" /> Pay {money(p.package_price)} to unlock
                    </button>
                  : p.deliverables_url
                  ? <a href={p.deliverables_url} target="_blank" rel="noreferrer" data-testid={`open-deliverable-${p.property_id}`}
                      className="flex items-center justify-center gap-2 w-full bg-[#4A0000] text-white rounded-md py-2 text-sm font-medium hover:bg-[#5C1A1A] transition-colors">
                      {role === "photographer" || role === "pilot" || role === "dual" ? <><UploadSimple size={16} weight="bold" /> Open your upload link</> : <><ArrowSquareOut size={16} weight="bold" /> Open deliverables</>}
                    </a>
                  : <p className="text-xs text-[#5C5A58] text-center py-1">{role === "photographer" || role === "pilot" || role === "dual" ? "Upload link coming soon." : "Awaiting delivery link."}</p>}
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
}
